<template>
  <v-container fluid class="investfund-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Fund</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Photo</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">New Fund</p>
                        <v-text-field
                          class="mb-4"
                          type="Number"
                          v-model="new_investfund.fundrank"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Fund Rank"
                          persistent-hint
                          single-line hint="Enter the fund rank">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="new_investfund.fundcode"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Fund Code"
                          persistent-hint
                          single-line hint="Enter the fund Code">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="new_investfund.fundname"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Fund Name"
                          persistent-hint
                          single-line hint="Enter the fund name">
                        </v-text-field>
                        <v-select
                          class="mb-4"
                          :items=investfund_types
                          v-model="new_investfund.fundtype"
                          v-bind:error="errorindex == 3"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the fund type">
                        </v-select>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>

                        <v-select
                          class="mb-4"
                          :items="accounts.filter(x=>x.accountsubclass=='Other Asset').map(x => {return {text: x.accountname, value: x._id};})"
                          v-model="new_investfund.asset_accountid"
                          outlined
                          dense
                          placeholder="Asset Account"
                          persistent-hint
                          single-line hint="Please choose the asset account">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="accounts.filter(x=>x.accountsubclass=='Other Asset').map(x => {return {text: x.accountname, value: x._id};})"
                          v-model="new_investfund.cash_accountid"
                          outlined
                          dense
                          placeholder="Cash Account"
                          persistent-hint
                          single-line hint="Please choose the cash account">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="accounts.filter(x=>x.accountsubclass=='Bank').map(x => {return {text: x.accountname, value: x._id};})"
                          v-model="new_investfund.bank_accountid"
                          outlined
                          dense
                          placeholder="Bank Account"
                          persistent-hint
                          single-line hint="Please choose the bank account">
                        </v-select>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          class="mb-4"
                          :items="accounts.filter(x=>x.accountsubclass=='Other Income').map(x => {return {text: x.accountname, value: x._id};})"
                          v-model="new_investfund.dividend_accountid"
                          outlined
                          dense
                          placeholder="Dividend Account"
                          persistent-hint
                          single-line hint="Please choose the dividend account">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="accounts.filter(x=>x.accountsubclass=='Other Income').map(x => {return {text: x.accountname, value: x._id};})"
                          v-model="new_investfund.interest_accountid"
                          outlined
                          dense
                          placeholder="Interest Account"
                          persistent-hint
                          single-line hint="Please choose the interest account">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="accounts.filter(x=>x.accountclass=='Expense').map(x => {return {text: x.accountname, value: x._id};})"
                          v-model="new_investfund.expense_accountid"
                          outlined
                          dense
                          placeholder="Expense Account"
                          persistent-hint
                          single-line hint="Please choose the expense account">
                        </v-select>
                      </v-form>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md=12>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/investfund/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkError">
                            Next
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">Upload Photo</p>
                        <p>Photo:</p>

                        <v-file-input label="File input" v-on:change="onFileChange" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                        <div class="d-flex justify-center">
                          <v-btn
                            outlined
                            color="primary"
                            @click="step = 1"
                          >
                            Back
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="insertInvestFund()">
                            Save
                          </v-btn>
                        </div>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      imageurl: undefined,
      new_investfund: {},
      investfund_types: ['Stocks', 'Bonds'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
    }
  },
  computed: {
    ...mapState('Account', ['accounts']),
    ...mapState('InvestFund', ['isReceiving']),
  },
  methods: {
    ...mapActions('Account', ['getAccountsRequest']),
    ...mapActions('InvestFund', ['insertInvestFundRequest','getInvestFundsRequest']),
    checkError(){
      if(!this.new_investfund.fundrank){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.new_investfund.fundcode){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.new_investfund.fundname){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      if(!this.new_investfund.fundtype){
        this.haserrors = true;
        this.errorindex = 3;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    async insertInvestFund() {
      await this.insertInvestFundRequest(this.new_investfund)
      router.push('/investfund/list')
    },
    createImage(file) {
      const reader = new FileReader();

      reader.onload = e => {
        this.imageurl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onFileChange(file) {
      if (!file) {return;}
      this.new_investfund.investfundimage = file;
      this.new_investfund.imagename = file.name;
      this.createImage(file);
    }
  },
  async created(){
    if(this.accounts.length==0) await this.getAccountsRequest();
  }
}
</script>

<style src="./Add.scss" lang="scss"></style>
